import { BillItem as ServerBillItem, BillItemOptions } from 'server/models/BillItem';
import { NumberOfUnits, TotalPriceForCharge } from 'data/models/Charge';
import { ImmutablePrice } from 'data/models/Price';
import { IQuickBooksInventoryItemTracking, QuickBooksInventoryItemTrackingWithDefaults } from 'data/models/QuickBooksInventoryItemTracking';

export { BillItemOptions, BillItemData } from 'server/models/BillItem';

export class BillItem extends ServerBillItem {
    QBTracking : IQuickBooksInventoryItemTracking;
    Total : ImmutablePrice;

    constructor();
    constructor(data : BillItemOptions);
    constructor(data : BillItemOptions | null = null) {
        super(data || { Id: 0 });

        this.QBTracking = QuickBooksInventoryItemTrackingWithDefaults(this.QBTrackingOverrides, () => this.StandardItem() && this.StandardItem()!.QBTracking);
        this.Total = TotalPriceForCharge(this);
    }

    NumberOfUnits() {
        return NumberOfUnits(this);
    }
}



// WEBPACK FOOTER //
// ./data/models/BillItem.ts